import { render, staticRenderFns } from "./AInscripcionEstadoAdministrativo.vue?vue&type=template&id=067a1a28&scoped=true"
import script from "./AInscripcionEstadoAdministrativo.vue?vue&type=script&lang=js"
export * from "./AInscripcionEstadoAdministrativo.vue?vue&type=script&lang=js"
import style0 from "./AInscripcionEstadoAdministrativo.vue?vue&type=style&index=0&id=067a1a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a1a28",
  null
  
)

export default component.exports